import React from 'react';
import Loading from './Loading';

const GlobalLoading = () => (
    <div className="global-loading">
        <Loading center={true} />
    </div>
);

export default GlobalLoading;
